const messagesFr = {
  accessCodeRequired:
    "Cette offre exclusive nécessite un code d'accès fourni par votre organisation.",
  accessOffer: "Accéder à l'offre",
  add: 'Ajouter',
  addOption: "Ajouter l'option",
  addOptionToAllParticipants: "Ajouter l'option à tous les participants",
  addParticipant: 'Ajouter un participant',
  addParticipantInfo: 'Ajouter les informations du participant numéro {numberParticipant}',
  addToCart: 'Ajouter au panier',
  afternoon: 'Après-midi',
  age: 'Age',
  ageBetween: "L'âge doit être compris entre {min} et {max} ans.",
  appliedPromotions: 'Promotions appliquées',
  availability: 'Disponibilités',
  back: 'Retour',
  backToProduct: 'Retour au produit',
  black: '{count, plural, one {# noire} other {# noires}}',
  blue: '{count, plural, one {# bleue} other {# bleues}}',
  cancel: 'Annuler',
  cartActionCheckout: 'Passer commande',
  cartActionClear: 'Vider le panier',
  cartAriaOpen: 'Ouvrir le panier',
  cartAriaRemoveParticipant: 'Retirer ce participant',
  cartAriaRemoveProduct: 'Retirer ce produit',
  cartClearBody:
    'Tous les produits et participants seront supprimés. Vous devrez reconstruire votre sélection.',
  cartClearConfirm: 'Vider le panier',
  cartClearTitle: 'Vider tout le panier ?',
  cartDialogCancel: 'Annuler',
  cartEmptyBodyDrawer:
    'Parcourez le catalogue et ajoutez vos premiers produits pour démarrer votre commande.',
  cartEmptyTitle: 'Votre panier est vide',
  cartOptionCount: '{count, plural, one {# option} other {# options}}',
  cartParticipantCount: '{count, plural, one {# participant} other {# participants}}',
  cartRemoveProductBody:
    'Tous les participants et options associés seront retirés. <strong>Cette action est définitive.</strong>',
  cartRemoveProductConfirm: 'Retirer ce produit',
  cartRemoveProductTitle: 'Retirer ce produit du panier ?',
  cartStepLabel: 'PANIER',
  cartSubTotal: 'Sous-total',
  cartTitle: 'Mon panier',
  cartTitleParticipantCount: '· {count, plural, one {# participant} other {# participants}}',
  cartTotal: 'Total',
  cartTotalTaxSub: 'TTC · TVA incluse',
  cartTrustFlexible: 'Annulation flexible',
  cartTrustSecure: 'Paiement sécurisé',
  checkSpecialInfo: 'Vérifiez les informations spéciales pour cette durée !',
  chooseATimeslot: 'Choisir un créneau horaire :',
  chooseValidityCategory: 'Choisissez une durée de {validityCategoryName} pour ce produit',
  close: 'Fermer',
  closeModal: 'Fermer cette fenêtre',
  code: 'Code',
  confirm: 'Confirmer',
  continue: 'Continuer',
  date: 'Date',
  discount: 'Promotion',
  discover: 'Découvrir',
  domainInformation: 'Informations du domaine',
  duration: 'Durée',
  'dynamicPriceCalendar.bestPrice': 'meilleur prix',
  'dynamicPriceCalendar.chooseDayAriaLabelPrefix': 'Choisir',
  'dynamicPriceCalendar.defaultCategoryName': 'adulte',
  'dynamicPriceCalendar.disabledDayAriaLabelPrefix': 'Non disponible',
  'dynamicPriceCalendar.disclaimer':
    "Prix affichés pour 1 {categoryName}, en {currency}, arrondis à l'entier supérieur, susceptibles de varier selon les disponibilités, et confirmés lors de la sélection des participants.",
  'dynamicPriceCalendar.inRange': 'dans la sélection',
  'dynamicPriceCalendar.monthAriaLabelPrefix': 'Calendrier',
  'dynamicPriceCalendar.nextMonthAriaLabel': 'Mois suivant',
  'dynamicPriceCalendar.originalPrice': 'prix initial',
  'dynamicPriceCalendar.previousMonthAriaLabel': 'Mois précédent',
  'dynamicPriceCalendar.selectedDate': 'sélectionné',
  'dynamicPriceCalendar.unavailable': 'non disponible',
  dynamicPriceDiscount: "Vous bénéficiez d'un tarif promotionnel !",
  edit: 'Modifier',
  error: 'Erreur',
  errorPageMessage1: "Ce n'est pas ainsi que l'histoire devait se dérouler.",
  errorPageMessage2: 'Nous y travaillons et tout reviendra bientôt à la normale.',
  errorPageTitle: 'Désolé, nous avons un problème...',
  finalPrice: 'Prix final',
  found: 'Nous avons trouvé',
  free: 'Gratuit',
  goBackToHome: "Retour à l'accueil",
  green: '{count, plural, one {# verte} other {# vertes}}',
  howOldIsTheParticipant: "Quel est l'âge de ce participant ?",
  includedAdvantages: 'Avantages inclus dans cette offre',
  indicativePrice: 'Prix indicatif pour 1 participant, 1 jour',
  initialPrice: 'Prix initial',
  invalidProductCode: 'Ce code n’est pas valide',
  kmOfSlopes: 'km de pistes',
  loading: 'Chargement...',
  moreInformation: "Plus d'informations",
  morning: 'Matin',
  noData: 'Pas de données trouvées',
  noDateSelected: 'Aucune date sélectionnée',
  noDomainAvailable: 'Aucun domaine disponible pour le moment.',
  noDurationAvailable: 'Aucune durée disponible pour le moment.',
  noOptionSelected: 'Aucune option sélectionnée',
  noParticipant: 'Aucun participant',
  noProductForSelectedDuration: 'Impossible de charger les informations. Veuillez réessayer.',
  noSeats: 'Plus de créneaux disponibles à la réservation.',
  options: 'Options',
  participant: 'Participant',
  participantTitle: '{count, plural, one {# Participant} other {# Participants}}',
  participants: 'Participants',
  participantsReachedLimit: 'Le nombre maximum de participants a été atteint.',
  perAdult: 'Par adulte',
  priceDetails: 'Détails du prix',
  priceSummary: 'Récapitulatif du prix',
  red: '{count, plural, one {# rouge} other {# rouges}}',
  refreshPage: 'Rafraîchir la page',
  remove: 'Supprimer',
  resort: 'Station',
  restrictedAccess: 'Accès restreint',
  results: '{count, plural, one {# résultat} other {# résultats}}',
  seats: '{count, plural, one {# place} other {# places}}',
  seeLess: 'Voir moins',
  seeMore: 'Voir plus',
  selectDates: 'Sélectionner les dates',
  selectOptions: 'Sélectionner les options',
  selectOrDeselectParticipants: 'Sélectionner ou désélectionner les participants :',
  showPricesFor: 'Afficher les prix pour :',
  skiLifts: 'remontées mécaniques',
  slopes: 'pistes',
  slopesBreakdown: 'Répartition des pistes',
  specialInfo: 'Informations spéciales',
  timeslots: 'Créneaux horaires',
  today: "Aujourd'hui",
  tomorrow: 'Demain',
  total: 'Total',
  unableToCalculatePrice: 'Impossible de calculer un prix. Veuillez réessayer plus tard.',
  undatedProductMessage: 'Aucune date requise',
  viewDetails: 'Voir les détails',
  yearsNumber: '{count, plural, one {# an} other {# ans}}',
  yearsRange: '{ageMin}-{ageMax} ans',
  youSaved: 'Vous économisez',
  domain: 'Domaine',
  chooseDomain: 'Choisir le domaine {categoryName}',
  buy: 'Acheter',
  purchaseDrawerTitle: 'Votre sélection',
  'purchaseCallToAction.title': 'Achat & Rechargement',
  'purchaseCallToAction.subtitle':
    'Choisissez vos dates et le nombre de participants pour un achat ou un rechargement immédiat.',
  'purchaseCallToAction.buttonLabel': 'Je réserve',
  purchaseStepConfiguration: 'CONFIGURATION',
  purchaseStepOptions: 'OPTIONS',
  closeConfirmationTitle: 'Vous n\u2019êtes pas prêt à passer commande ?',
  closeConfirmationDescription: 'Votre sélection en cours sera perdue si vous quittez maintenant.',
  closeConfirmationKeep: 'Continuer ma réservation',
  closeConfirmationLeave: 'Quitter',
  'upsell.dateChanged': 'Vos dates de séjour ont été modifiées',
  'upsell.days': '{count, plural, one {# jour} other {# jours}}',
  'upsell.included': 'Inclus',
  'upsell.moreInfo': 'En savoir plus',
  'upsell.select': 'Sélectionner',
  'upsell.title': 'Surclassez votre forfait',
};

export default messagesFr;
